const TotalAsset = resolve => {
  import(/* webpackChunkName: 'TotalAsset' */'../views/asset/TotalAsset').then(TotalAsset => {
    resolve(TotalAsset)
  })
}

const DueInEarnings = resolve => {
  import(/* webpackChunkName: 'DueInEarnings' */'../views/asset/DueInEarnings').then(DueInEarnings => {
    resolve(DueInEarnings)
  })
}

export default [
  {
    path: '/asset/total',
    name: 'TotalAsset',
    component: TotalAsset
  },
  {
    path: '/asset/dueInEarnings',
    name: 'DueInEarnings',
    component: DueInEarnings
  }
]
